import * as React from "react";
// import useNotification from "../common/Notification";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    IconButton,
    Stepper,
    Step,
    StepLabel,
    Paper,
    Chip,
    Avatar,
    Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
// import CustomizedDrawer from "../Email/CustomizedDrawer";
// import { useConfirmation } from "../../context/ConfirmationDialogProvider";
// import MessageStep from "./AddMessageSteppersCmp/MessageStep";
import { teal } from "@mui/material/colors";

const base_url = "http://api.virtualprachar.com/api/whatsapp/personal/group";
const baseUrl =
    "http://api.virtualprachar.com/api/whatsapp/personal/whatsapp_queue";

const steps = ["Message", "Attachments", "Recipients"];

const RecipientStep = ({
    phoneValue,
    phoneNumber,
    contacts,
    searchedGName,
    options,
    loading,
    page,
    totalPage,
    onPhoneChange,
    onAddNumber,
    onDelete,
    onSelectionChange,
    onFetchGroupData,
    onClearContacts,
    onSelectPriority
}) => {

       const [selectedPriority, setSelectedPriority] = useState(null);

    // Generate 10 priority chips with decreasing opacity
    const priorityChips = Array.from({ length: 10 }, (_, index) => {
        const priorityNumber = index + 1;
        const opacity = 1 - (index * 0.09); // Decreasing opacity from 1 to 0.1
        const backgroundColor = `rgba(0, 128, 128, ${opacity})`
        return {
            priorityNumber,
            opacity,
            backgroundColor,
            label: `Priority ${priorityNumber}`
        };
    });

    const handlePriorityClick = (priorityNumber) => {
        setSelectedPriority(priorityNumber);
        if(onSelectPriority){
            console.log("ON SELECT PRIORITY NUMBER: ", priorityNumber)
            onSelectPriority(priorityNumber)
        }
    };


    return (
        <Box sx={{ width: "100%" }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Select Priority for your message
            </Typography>

            {/* Priority Chips */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
                {priorityChips.map((chip, i) => (
                    <Chip
                        key={chip.priorityNumber}
                        label={chip.label}
                        onClick={() => handlePriorityClick(chip.priorityNumber)}
                        sx={{
                            backgroundColor:  i === 0 ? "#013930ff" : teal[(10-i)*100],
                            color: "white",
                            fontWeight: "bold",
                            "&:hover": {
                                backgroundColor: `rgba(25, 118, 210, ${Math.min(chip.opacity + 0.2, 1)})`,
                            },
                            ...(selectedPriority === chip.priorityNumber && {
                                border: "2px solid rgba(8, 105, 21, 1)",
                            })
                        }}
                    />
                ))}
            </Box>
               {/* Selected Priority Message */}
            {selectedPriority && (
                <Paper
                    sx={{
                        p: 2,
                        mb: 3,
                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                        border: "2px solid rgba(8, 105, 21, 1)",
                        borderRadius: 2,
                        textAlign: "center"
                    }}
                >
                    <Typography variant="h6" sx={{color:"rgba(8, 105, 21, 1)"}} fontWeight="bold">
                        You selected priority number {selectedPriority}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        This message will be sent with {selectedPriority === 1 ? "highest" : "high"} priority
                    </Typography>
                </Paper>
            )}

            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Select Recipients
            </Typography>

            <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel size="small">Select a group</InputLabel>
                    <Select
                        value={searchedGName}
                        label="Select a group"
                        onChange={onSelectionChange}
                        size="small"
                    >
                        {options.map((option, i) => (
                            <MenuItem key={i} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Button
                    variant="outlined"
                    size="small"
                    onClick={onFetchGroupData}
                    disabled={!searchedGName}
                >
                    Search
                </Button>
            </Box>

            {!searchedGName && (
                <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                    <TextField
                        label="Phone No With Country Code (eg: 919999999999)"
                        variant="outlined"
                        size="small"
                        value={phoneValue}
                        onChange={onPhoneChange}
                        sx={{ flexGrow: 1 }}
                    />
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onAddNumber}
                        disabled={!phoneValue}
                    >
                        ADD
                    </Button>
                </Box>
            )}

            <Paper
                sx={{
                    p: 2,
                    minHeight: 200,
                    maxHeight: 300,
                    overflowY: "auto",
                    bgcolor: "#f5f5f5",
                }}
            >
                {contacts.length === 0 ? (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ textAlign: "center", py: 4 }}
                    >
                        {searchedGName
                            ? "No group members found"
                            : "Added contacts will appear here"}
                    </Typography>
                ) : (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {contacts.map((contact, idx) => (
                            <Chip
                                key={idx}
                                label={contact.phoneNumber}
                                onDelete={() => onDelete(idx)}
                                sx={{ mb: 1 }}
                            />
                        ))}
                        {loading && (
                            <CircularProgress size={24} sx={{ mx: "auto" }} />
                        )}
                        {!loading && page < totalPage && (
                            <Button
                                variant="text"
                                size="small"
                                onClick={onFetchGroupData}
                                sx={{ width: "100%" }}
                            >
                                Load More
                            </Button>
                        )}
                    </Box>
                )}
            </Paper>

            {contacts.length > 0 && (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={onClearContacts}
                    sx={{
                        mt: 2,
                        color: "error.main",
                        borderColor: "error.main",
                    }}
                >
                    {searchedGName ? "Clear Group" : "Clear Contacts"}
                </Button>
            )}
        </Box>
    );
};

export default RecipientStep;
